import React from "react";

function Header() {
  return (
    <>
      <div className="header">
        <div className="lbox">
          <a href="" className="logo animated fadeInUp">
            <img src="./images/logo.svg" alt="" />
          </a>
          <div className="links">
            <a
              href=""
              className="animated fadeInUp"
              style={{ animationDelay: "100ms" }}
            >
              Home
            </a>
            <a
              href="https://wekruit-case-interview.web.app/dashboard"
              className="animated fadeInUp"
              style={{ animationDelay: "200ms" }}
            >
              Demo
            </a>
            <a
              href="https://linktr.ee/wekruit"
              className="animated fadeInUp"
              style={{ animationDelay: "300ms" }}
            >
              Community
            </a>
            <a
              href="https://linktr.ee/wekruit"
              className="animated fadeInUp"
              style={{ animationDelay: "400ms" }}
            >
              Contact
            </a>
          </div>
        </div>
        <div className="rbox">
          <a
            href="https://wekruit-case-interview.web.app/dashboard"
            className="common_btn_bg animated fadeInUp"
            style={{ animationDelay: "500ms" }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="19"
              viewBox="0 0 17 19"
              fill="none"
            >
              <path
                d="M11.8885 9.86028C12.0257 9.7647 12.0943 9.63301 12.0943 9.4652C12.0943 9.29739 12.0257 9.1657 11.8885 9.07013L6.8905 5.79913C6.73667 5.69299 6.58183 5.68447 6.426 5.77357C6.27017 5.86267 6.19225 5.99965 6.19225 6.18449V12.7459C6.19225 12.9308 6.27017 13.0677 6.426 13.1568C6.58183 13.2459 6.73667 13.2374 6.8905 13.1313L11.8885 9.86028ZM1.80775 18.1538C1.30258 18.1538 0.875 17.9749 0.525 17.6171C0.175 17.2594 0 16.8223 0 16.3059V2.62447C0 2.1081 0.175 1.67103 0.525 1.31326C0.875 0.955494 1.30258 0.776611 1.80775 0.776611H15.1923C15.6974 0.776611 16.125 0.955494 16.475 1.31326C16.825 1.67103 17 2.1081 17 2.62447V16.3059C17 16.8223 16.825 17.2594 16.475 17.6171C16.125 17.9749 15.6974 18.1538 15.1923 18.1538H1.80775ZM1.80775 16.6205H15.1923C15.2692 16.6205 15.3398 16.5877 15.4038 16.5221C15.4679 16.4567 15.5 16.3846 15.5 16.3059V2.62447C15.5 2.54576 15.4679 2.4737 15.4038 2.40828C15.3398 2.34269 15.2692 2.30989 15.1923 2.30989H1.80775C1.73075 2.30989 1.66025 2.34269 1.59625 2.40828C1.53208 2.4737 1.5 2.54576 1.5 2.62447V16.3059C1.5 16.3846 1.53208 16.4567 1.59625 16.5221C1.66025 16.5877 1.73075 16.6205 1.80775 16.6205Z"
                fill="white"
              />
            </svg>
            <p>Try WeKruit</p>
          </a>
          {/* <a
            href="https://wekruit-case-interview.web.app/dashboard/login"
            className="common_btn animated fadeInUp"
            style={{ animationDelay: "600ms" }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="19"
              height="18"
              viewBox="0 0 19 18"
              fill="none"
            >
              <path
                d="M9.36525 17.4977C9.10758 17.4977 8.85825 17.442 8.61725 17.3305C8.37625 17.2191 8.16533 17.054 7.9845 16.8353L0.4115 7.56073C0.274333 7.39309 0.171417 7.21004 0.10275 7.01156C0.03425 6.81292 0 6.60422 0 6.38547C0 6.24509 0.0140834 6.10386 0.0422501 5.96177C0.0704167 5.81952 0.11975 5.68357 0.19025 5.55392L2.01725 1.81502C2.18125 1.507 2.40467 1.26065 2.6875 1.07597C2.97017 0.891128 3.28392 0.798706 3.62875 0.798706H15.1018C15.4466 0.798706 15.7603 0.891128 16.043 1.07597C16.3258 1.26065 16.5492 1.507 16.7132 1.81502L18.5403 5.55392C18.6108 5.68357 18.6601 5.81952 18.6882 5.96177C18.7164 6.10386 18.7305 6.24509 18.7305 6.38547C18.7305 6.60422 18.6962 6.81292 18.6278 7.01156C18.5591 7.21004 18.4562 7.39309 18.319 7.56073L10.746 16.8353C10.5652 17.054 10.3543 17.2191 10.1133 17.3305C9.87225 17.442 9.62292 17.4977 9.36525 17.4977ZM6.58625 5.90964H12.1442L10.394 2.33199H8.3365L6.58625 5.90964ZM8.61525 15.2292V7.44292H2.28625L8.61525 15.2292ZM10.1152 15.2292L16.4443 7.44292H10.1152V15.2292ZM13.8115 5.90964H17.0192L15.3558 2.50883C15.3301 2.45652 15.2916 2.41393 15.2402 2.38105C15.1889 2.34834 15.1344 2.33199 15.0768 2.33199H12.0613L13.8115 5.90964ZM1.71125 5.90964H4.919L6.66925 2.33199H3.65375C3.59608 2.33199 3.54158 2.34834 3.49025 2.38105C3.43892 2.41393 3.40042 2.45652 3.37475 2.50883L1.71125 5.90964Z"
                fill="#898989"
              />
            </svg>
            <p>Log in</p>
          </a> */}
        </div>
      </div>
      <div className="pheader">
        <div className="menu">
          <div className="l">
            <a
              href="./index.html"
              target="_self"
              className="animated fadeInUpLeft"
            >
              <img src="./images/logo.svg" alt="" />
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
